module.exports = __webpack_public_path__ + "img/20210731_144634.2163ec6f.jpg";